<template>
  <div :class="`post-header ${isRepost ? 'post-header--repost' : ''}`">
    <div class="post-source">
      <a :href="post.author_url ? post.author_url : '#'" target="_blank" class="post-source__img-wrap" rel="noreferrer">
        <img :src="post.author_logo" alt="" class="post-source__img" v-if="post.author_logo" referrerpolicy="no-referrer">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" x="0px" y="0px" viewBox="0 0 70 70" class="post-source__img" v-if="!post.author_logo" >
          <circle cx="35" cy="35" r="35" fill="#EEEEEE"/>
          <path d="M53.74939,48.28949c-0.75598-0.74872-1.77271-1.65887-2.26318-2.14459 c-2.63391-2.22192-5.73602-3.92212-9.1308-4.92682c4.1167-2.47296,6.88708-6.97467,6.88708-12.09467 C49.24249,21.31781,42.86273,15,34.98053,15s-14.26215,6.33722-14.26215,14.12341c0,5.12,2.75104,9.6217,6.88721,12.09467 c-3.35577,1.0047-6.41888,2.68561-9.03326,4.86884c-0.29785,0.29486-0.70184,0.50177-2.34125,2.12531 c-2.80945,3.01398-4.89709,6.72357-5.97015,10.81958l-0.10785,0.61395C16.49463,66.03876,25.28387,70,35,70 c9.68921,0,18.4577-3.93823,24.79517-10.29999l-0.13409-0.66821C58.58801,54.95508,56.53943,51.30353,53.74939,48.28949z" fill="#BBBBBB"/>
        </svg>
          <div class="post-body__additional">
            <img src="../../../../../../../assets/img/vk-icon.svg" width="16px" v-if="post.network_name === 'vk'">
            <img src="../../../../../../../assets/img/ok-icon.svg" width="16px" v-if="post.network_name === 'ok'">
            <img src="../../../../../../../assets/img/twitter.svg" width="16px" v-if="post.network_name === 'tw'">
            <img src="../../../../../../../assets/img/telegram.svg" width="16px" v-if="post.network_name === 'tg'">
            <img src="../../../../../../../assets/img/facebook.svg" width="16px" v-if="post.network_name === 'fb'">
            <img src="../../../../../../../assets/img/ig.png" width="16px" v-if="post.network_name === 'ig'">
            <img src="../../../../../../../assets/img/gs.svg" width="16px" v-if="post.network_name === 'gs'">
            <img src="../../../../../../../assets/img/yt.png" width="18px" v-if="post.network_name === 'yt'">
          </div>
      </a>

      <div class="post-source__info">
        <a :href="post.author_url ? post.author_url : '#'" target="_blank" class="post-source__title">
          {{post.author ? post.author : 'Не определен'}}
        </a>
        <a :href="post.uri" target="_blank" class="post-source__date">
          {{getDate(post.created_date)}}
        </a>
      </div>
            <span class="post-info-panel__item to-ex" style="font-size: 12px;font-weight: bold;margin-left: 20px;" v-if="this.excluded == !post.id" @click="addExSource(post)">{{$t('post.postInfoPanel.excludeSource')}}</span>
            <span class="post-info-panel__item to-ex" style="font-size: 12px;font-weight: bold;margin-left: 20px;" v-if="this.excluded == post.id" >Источник будет исключен из выдачи</span>
    </div>

    <div class="post-social">
      <ul class="post-social-list">
        <li v-if="post.network_id != '4' && post.engagementrate" class="post-social-list__item">
          <img src="../../../../../../../assets/img/reaction.svg" alt="">
          {{Math.round(post.engagementrate)}}%
        </li>
        <li v-if="post.network_id != '4' && post.viewed != 0 && !post.engagementrate" class="post-social-list__item">
          <img src="../../../../../../../assets/img/reaction.svg" alt="">
          {{Math.ceil((+post.likes / +post.viewed) *100) + "%"}}
        </li>
        <li v-if="post.network_id != '4'" class="post-social-list__item">
          <img src="../../../../../../../assets/img/favorite.svg" alt="">
          {{post.likes}}
        </li>
        <li v-if="post.network_id != '4'" class="post-social-list__item">
          <img src="../../../../../../../assets/img/reply.svg" alt="">
          {{post.reposts}}
        </li>
        <li v-if="post.network_id != '4'" class="post-social-list__item">
          <img src="../../../../../../../assets/img/mode_comment.svg" alt="">
          {{post.comments}}
        </li>
        <li v-if="post.network_id != '4'" class="post-social-list__item">
          <img src="../../../../../../../assets/img/visibility.svg" alt="">
          {{post.viewed}}
        </li>
        <li class="post-social-list__item">
          <img src="../../../../../../../assets/img/people.svg" style="width: 15px" alt="">
          {{post.attendance}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { addStopSourcesApi } from "../../../../../../../api/feeds";

  export default {
    name: 'PostHeader',
    props: {
      post: {
        type: Object
      },
      isRepost: {
        type: Boolean
      }
    },
    data() {
      return {
        excluded: 0,
      }
    },
    methods: {
      addExSource(post) {
              let params = {
              thread_id: this.$route.params.threadId,
              profile_id: post.owner_id,
              network_id: post.network_id,
            };

            addStopSourcesApi(params).then(resp => {
              this.$emit('updateSources', resp.data);

              this.excluded = post.id;
            });
            this.excluded = post.id;
      },
      getDate(dateTime) {
        let dateTimeArr = dateTime.split(' ');
        let dateArr = dateTimeArr[0].split('-');

        return dateArr[2]+'.'+dateArr[1]+'.'+dateArr[0].slice(2, dateArr[0].length)+' '+dateTimeArr[1];
      }
    }
  };
</script>

<style>
  .post-header {
    display: flex;
    justify-content: space-between;
  }

  .post-header--repost {
    border-top: 1px solid #ccc;
    padding-top: 20px;
    margin-top: 10px;
  }

  .copy-posts-wrap .post-info-panel__item{
    display: none;
  }

  .post-source,
  .post-source:hover,
  .post-source:visited,
  .post-source:active {
    text-decoration: none;
    color: inherit;
    display: flex;
  }
  .post-source__img-wrap {
    width: 40px;
    height: 40px;
    overflow: hidden;
    border-radius: 50%;
    margin-right: 15px;
  }
  .post-source__img {
    display: inline-block;
    width: 100%;
  }
  .post-source__info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .post-source__title {
    font-family: "Roboto", "Arial", sans-serif;
    font-weight: 300;
    font-size: 14px;
    margin-bottom: 5px;
    text-decoration: none;
    color: inherit;
    display: block;
  }

  .post-source__date {
    font-family: "Roboto", "Arial", sans-serif;
    font-weight: 300;
    font-size: 10px;
    text-decoration: none;
    color: inherit;
    display: block;
  }
  .post-social-list {
    display: flex;
    justify-content: space-between;
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .post-social-list__item {
    display: flex;
    align-items: center;
    font-family: "Roboto", "Arial", sans-serif;
    font-weight: 500;
    font-size: 12px;
    margin-right: 20px;
  }
  .post-social-list__item img {
    margin-right: 5px;
  }
  .post-social-list__item:last-child {
    margin-right: 0;
  }
  .wordfound {
    background-color: #ffcc00;
  }


  @media screen and (max-width: 480px) {
    .post-social-list__item {
      display: block;
    }
    .post-source__title{
      max-width: 180px;
    }
    .post-header {
      flex-wrap: wrap;
    }
    .post-social {
      width: 100%;
      margin-top: 10px;
    }
    .post-social-list__item {
      margin-bottom: 5px;
    }
  }
</style>
